import React from 'react';
import PropTypes from 'prop-types';

import {
  MAPBOX_GEOCODER,
  MAPBOX_GEOCODER_INPUT_ID,
  MAPBOX_GEOCODER_LABEL,
  MAPBOX_GEOCODER_NOT_AVAILABLE_MESSAGE,
} from 'constants/mapbox';
import { labelStyles } from 'constants/styles';

const MapboxGeocoder = (props) => {
  const { isSearchUsable } = props;

  const renderLabelOrNotAvailableMessage = () => {
    return (
      <React.Fragment>
        {isSearchUsable ? (
          <label style={labelStyles} htmlFor={MAPBOX_GEOCODER_INPUT_ID}>
            {MAPBOX_GEOCODER_LABEL}
          </label>
        ) : (
          <p>
            <small>{MAPBOX_GEOCODER_NOT_AVAILABLE_MESSAGE}</small>
          </p>
        )}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {renderLabelOrNotAvailableMessage()}
      <div id={MAPBOX_GEOCODER}></div>
    </React.Fragment>
  );
};

MapboxGeocoder.propTypes = {
  isSearchUsable: PropTypes.bool.isRequired,
};

export default MapboxGeocoder;
